module.exports = __webpack_public_path__ + "static/11-457dae7fc2115fbbebfe9555ee0dd82e.jpg";